import { useFilterState, FilterList, FilterValue, FilterValueList } from "@/store/useFilterState";

export class FilterService {
  private readonly _filterStateStore = useFilterState();

  constructor(
    private readonly _categoryCode: string,
    private readonly _availableFilters: Record<string, FilterValueList>
  ) {}

  /**
   * Returns the user's selected filters from state.
   * If no filters are found and an empty FilterList is returned.
   * The filters are filtered(!) against the available filters
   * defined on the current category in the backend so only existing filters are returned.
   */
  public loadSelectedFilters(): FilterList {
    // Retrieve the filters stored in the state for the current category code.
    const storedFilters = this._filterStateStore.state[this._categoryCode] || {};
    // The list of available filters read from props.
    const validFilters = {} as FilterList;
    let invalidFiltersFound = false;

    // Iterate over each filter in the stored filters.
    for (const key in storedFilters) {
      // Check if the stored filter category exists in the list of available filters.
      if (this._availableFilters[key]) {
        const storedValues = storedFilters[key];
        // Filter out the values that are not available for the current filter category.
        const validValues = storedValues.filter((storedValue: FilterValue) => {
          return this._availableFilters[key].includes(storedValue);
        });

        if (validValues.length !== storedValues.length) {
          invalidFiltersFound = true;
        }

        if (validValues.length > 0) {
          validFilters[key] = validValues;
        }
      } else {
        // Invalid filter key.
        invalidFiltersFound = true;
      }
    }

    // If any invalid values were found, update the state with the valid filters.
    if (invalidFiltersFound) {
      this.updateFilters(validFilters);
    }

    return validFilters;
  }

  public updateFilters(filters: FilterList): void {
    this._filterStateStore.update(this._categoryCode, filters);
  }
}
